export const getNoun = (count: number, forms: string[]): string => {
  const absCount = Math.abs(count);
  const lastDigit = absCount % 10;
  const lastTwoDigits = absCount % 100;

  // For languages with 3 forms (Cyrillic languages)
  if (forms.length >= 3) {
    // 1, 21, 31, 101, etc. (but not 11)
    if (lastDigit === 1 && lastTwoDigits !== 11) {
      return forms[0];
    }
    // 2-4, 22-24, 32-34, etc. (but not 12-14)
    if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
      return forms[1];
    }
    // 0, 5-20, 25-30, etc.
    return forms[2];
  }

  // For languages with 2 forms (e.g., English)
  if (absCount === 1) {
    return forms[0];
  }

  return forms[1] ?? forms[0];
};
